// @flow

import window from 'window';

import type { IGALog } from '..';


class GoogleAnalyticsApi {

	_ga: ?Object;
	_checkGAExistence: () => boolean;
	send: (log: CovariantOf<IGALog>) => void;

	constructor () {
		this._ga = window.ga;
	}

	send (log: CovariantOf<IGALog>) {
		if (!this._checkGAExistence()) {
			return;
		}

		this._ga('send', log);
	}

	_checkGAExistence (): boolean {
		if (!this._ga) {
			console.warn('ga action skipped due to undefined `ga` global');
			return false;
		}

		return true;
	}
}

export default new GoogleAnalyticsApi();
